import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { App1WrapperComponent } from './app1Wrapper.component';
import { NxWelcomeComponent } from './nx-welcome.component';
import { RouterModule } from '@angular/router';
import { App1RoutingModule } from './app1-routing.moudle';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { SharedLib1Module } from '@nxt/shared-lib1';
import { Test9Effects } from '../store/effects/test9.effects';
// import * as fromTest9 from './store/reducers/test9.reducers';
import * as fromTest9 from '../store/reducers/test9.reducers';
import { Test9MovieListComponent } from './components/test9-movie-list/test9-movie-list.component';
import { StoreModule } from '@ngrx/store';
import { AllMaterialModule } from '@nxt/shared-modules';
import { FormsModule } from '@angular/forms';
import { TestTranslateComponent } from './components/test-translate/test-translate.component';
import { App1HomeComponent } from './components/app1-home/app1-home.component';
import { App1ErrorHandleComponent } from './components/app1-error-handle/app1-error-handle.component';
import { SharedAuthModule, TokenInterceptor } from '@nxt/shared-auth';
import {
  ConfigService,
  LoggingLevel,
} from 'libs/shared-lib1/src/lib/shared/services/config-service.service';
import { NgHttpCachingConfig, NgHttpCachingModule } from 'ng-http-caching';
import { PrettyPrintJsonPipe } from 'libs/shared-lib1/src/lib/shared/pipes/pretty-print-json.pipe';
import { SafePipe } from 'libs/shared-lib1/src/lib/shared/pipes/safe-pipe.pipe';
import { catchError, map, of } from 'rxjs';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import {
  LocationStrategy,
  PathLocationStrategy,
  HashLocationStrategy,
} from '@angular/common';
import { APP_BASE_HREF } from '@angular/common';
import { GeocoderAutocomplete } from '@geoapify/geocoder-autocomplete';
import { CookieService } from 'ngx-cookie-service';
//import { TokenInterceptor2 } from './shared/token.interceptor';
import { RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, ReCaptchaV3Service, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { App1HeaderComponent } from './components/app1-header/app1-header.component';
import { DialogService } from 'libs/shared-lib1/src/lib/shared/services/decativateDialog/dialog.service';
import { ConfirmationGuard } from 'libs/shared-lib1/src/lib/shared/guards/confirmation.guard';
import { ConfirmationService } from 'primeng/api';
//import { CanDeactivateGuard } from 'libs/shared-lib1/src/lib/shared/services/can-deactivate.guard';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ExcelEditingComponent } from './components/excel-editing/excel-editing.component';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const ngHttpCachingConfig: NgHttpCachingConfig = {
  //lifetime: 1000 * 10 // cache expire after 10 seconds
  lifetime: 1000 * 10 * 10, // cache expire after 100 seconds
};

export function loadConfigFactory(http: HttpClient, config: ConfigService) {
  return config.Init('app1');
}

@NgModule({
  declarations: [
    App1WrapperComponent,
    NxWelcomeComponent,
    Test9MovieListComponent,
    TestTranslateComponent,
    App1HomeComponent,
    App1ErrorHandleComponent,
    PageNotFoundComponent,
    App1HeaderComponent,
    ExcelEditingComponent,
  ],
  imports: [
    FormsModule,
    SharedLib1Module,
    //SharedAuthModule, //WILL IMPACT ROUTING FOR APP1
    AllMaterialModule,
    BrowserModule,
    NgHttpCachingModule.forRoot(ngHttpCachingConfig),

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    App1RoutingModule,

    RouterModule.forRoot([], {
      initialNavigation: 'enabledBlocking',
      onSameUrlNavigation: 'reload',
    }),
    HttpClientModule,

    //StoreModule.forRoot(fromTest9.metaReducers),
    StoreModule.forRoot({}),
    StoreModule.forFeature(fromTest9.test9FeatureKey, fromTest9.test9Reducer, {
      metaReducers: fromTest9.metaReducers,
    }),

    EffectsModule.forRoot([]),
    EffectsModule.forFeature([Test9Effects]),

    PdfViewerModule,

    RecaptchaFormsModule,

    //   RecaptchaModule
    //OAuthModule.forRoot(),

    // // ngrx effects
    // EffectsModule.forRoot([
    //     ToDoEffects,
    //     ToDoEffectsTest6,
    //     CountriesEffects,
    //     //example 8
    //     MovieEffects
    // ]),
  ],
  providers: [
    CookieService,
    DialogService,
    ConfirmationService,
    ConfirmationGuard,
    {
      provide: HTTP_INTERCEPTORS,
      //useClass: TokenInterceptor2,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: APP_BASE_HREF,
      useValue: 'app1',
    },

    //https://stackoverflow.com/questions/52416210/angular-static-base-url-and-routing-with-usehash-true
    // { provide: LocationStrategy, useClass: PathLocationStrategy },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfigFactory,
      deps: [HttpClient, ConfigService],
      multi: true,
    },    
    ReCaptchaV3Service,
    //https://www.c-sharpcorner.com/article/implementing-google-recaptcha-v3-in-angular-14/
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: "6LdWnDclAAAAAClGlIJtFTyHI4nRzpJCTWw-kFXJ",
    }, 
    //https://www.google.com/recaptcha/admin/site/603318054/settings
    // {
    //   provide: RECAPTCHA_SETTINGS,
    //   useValue: {
    //     siteKey: "6Lcm5_UjAAAAADFR-alP6RcMPcSjSy3XNOcNzjda",
    //   } as RecaptchaSettings,
    // },

  ],

  bootstrap: [App1WrapperComponent],
})
export class App1Module {}
